"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAMobileIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FAMobileIcon = _ref => {
  var _item$specialFaIcon$n, _item$specialFaIcon$c, _item$specialFaIcon$c2, _item$specialFaIcon$c3, _item$faIcon, _item$iconColor$hexVa, _item$iconColor;

  let {
    item
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, item.specialFaIcon ? /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fad', (_item$specialFaIcon$n = item.specialFaIcon.name) !== null && _item$specialFaIcon$n !== void 0 ? _item$specialFaIcon$n : 'fish'],
    style: {
      height: '35px',
      width: '35px',
      marginRight: '5px',
      // border: `1px solid #F1F2F5`,
      // background: '#F1F2F5',
      // borderRadius: '5px',
      padding: '5px',
      '--fa-primary-color': (_item$specialFaIcon$c = (_item$specialFaIcon$c2 = item.specialFaIcon.colors[0]) === null || _item$specialFaIcon$c2 === void 0 ? void 0 : _item$specialFaIcon$c2.color) !== null && _item$specialFaIcon$c !== void 0 ? _item$specialFaIcon$c : '#AA23FF',
      '--fa-secondary-color': (_item$specialFaIcon$c3 = item.specialFaIcon.colors[1].color) !== null && _item$specialFaIcon$c3 !== void 0 ? _item$specialFaIcon$c3 : '#0cff00',
      '--fa-primary-opacity': 1,
      '--fa-secondary-opacity': 1
    }
  }) : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fad', (_item$faIcon = item.faIcon) !== null && _item$faIcon !== void 0 ? _item$faIcon : 'fish'],
    style: {
      height: '35px',
      width: '35px',
      marginRight: '5px',
      border: "1px solid #F1F2F5",
      background: '#F1F2F5',
      borderRadius: '5px',
      padding: '5px',
      color: (_item$iconColor$hexVa = (_item$iconColor = item.iconColor) === null || _item$iconColor === void 0 ? void 0 : _item$iconColor.hexValue) !== null && _item$iconColor$hexVa !== void 0 ? _item$iconColor$hexVa : '#002D5C'
    }
  }));
};

exports.FAMobileIcon = FAMobileIcon;